import {BootstrapIcon} from "../../../../services/header.service";
import {Userrole} from "../../../../shared/interfaces/user";

export interface DashboardButtonConfig {
  buttonClass: string;
  icon: BootstrapIcon;
  label: string;
  linkTarget: string;
  roleRequired?: Userrole;
  spacingClass?: string;
}

export const DASHBOARD_BUTTONS: DashboardButtonConfig[] = [
  {
    // button for Wissensdatenbank
    buttonClass: 'btn-qundis-primary',
    icon: BootstrapIcon.knowledgebase,
    label: 'Wissensdatenbank',
    linkTarget: '/kd',
    spacingClass: 'pb-2 pt-0 mb-2 mt-0'
  },
  {
    // button for Stillstandsmeldung
    buttonClass: 'btn-qundis-warn',
    icon: BootstrapIcon.standstill,
    label: 'Stillstandsmeldung',
    linkTarget: '/er'
  },
  {
    // button for Eskalationen
    buttonClass: 'btn btn-qundis-orange',
    icon: BootstrapIcon.escalation,
    label: 'Eskalationen',
    linkTarget: '/escalations',
    roleRequired: Userrole.Mitarbeiter // Button won't show for this role
  },
  {
    // button for Stillstandshistorie
    buttonClass: 'btn-qundis-grey-darker',
    icon: BootstrapIcon.workplaces,
    label: 'Stillstandshistorie',
    linkTarget: '/workplaces'
  }
]
